<template>
  <div class="flex space-x-3 relative z-30">
    <ContextCategorySelector
      :category="selectedCategory"
      :categories="categories"
      :loading="loading"

      @select="selectCategory"
    />
    <ContextProductSelector
      v-if="!loading && selectedCategory"
      :category="selectedCategory"

      @select="selectProduct"
    />
  </div>
</template>

<script>

import ContextCategorySelector from "./ContextCategorySelector.vue"
import ContextProductSelector from "./ContextProductSelector.vue"

import { mapGetters } from "vuex"

export default {
  components: {
    ContextCategorySelector,
    ContextProductSelector,
  },
  data() {
    return {
      loading: true,
      categories: [],
    }
  },
  async created() {
    this.loading = true

    this.categories = (await this.$store.dispatch("cachedGet", {
      endpoint: `${this.link}/rest/V1/editor/list-available-categories`,
      headers: { Cookie: 'environment=editor' },
    })).data || []
    this.$emit("category", this.getCategoryWithTheMostProducts())

    this.loading = false
  },
  beforeDestroy() {
    this.setContext(null)
  },
  methods: {
    selectCategory(categoryId) {
      categoryId && this.setContext({ categoryId })
    },
    selectProduct(product) {
      console.log("product: ", product)
      if (product) {
        this.setContext({ productId: product.id })
        this.$emit('product', product)
      }
    },
    getCategoryWithTheMostProducts() {
      let categoryWithTheMostProducts = null
      const categories = this.flattenedCategories
      for (const cat of categories) {
        if (!categoryWithTheMostProducts || cat.products > categoryWithTheMostProducts.products) {
          categoryWithTheMostProducts = cat
        }
      }

      categoryWithTheMostProducts && this.selectCategory(categoryWithTheMostProducts.id)
      return categoryWithTheMostProducts
    },
    setContext(context) {
      this.$store.dispatch("editor/context", context)
    },
    flattenCategories(cat, flattened) {
      flattened.push(cat)

      if (cat.children && cat.children.length) {
        for (const cat of cat.children) {
          this.flattenCategories(cat, flattened)
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      context: 'editor/context',
    }),

    flattenedCategories() {
      const flattened = []

      for (const cat of this.categories) {
        this.flattenCategories(cat, flattened)
      }

      return flattened
    },
    selectedCategory() {
      const context = this.context
      if (!context) return;

      for (const cat of this.categories) {
        if (cat.id === context.categoryId) return cat

        const subCat = cat.children.find(subCat => subCat.id === context.categoryId)
        if (subCat) return subCat
      }
    },
  },
}

</script>
